<template>
  <page :loading="loading">
    <template #content>
      <SubTopBar />
    <v-breadcrumbs
      :items="bcItems"
      divider=">"
      class="mt-1"
      large
      />
      <v-form ref="form" v-model="valid">
          <v-row>
            <v-col cols="12" class="mb-n5">
              <v-combobox
                v-model="authorization"
                :items="items"
                label="Role *"
                outlined
                dense
                required
              />
            </v-col>
            <v-col cols="12" class="mb-n5">
              <v-text-field
                v-model="member"
                ref="member"
                outlined
                dense
                required
                :rules="[global.rules.memberReference]"
                label="Username, Email or Phone number *"
              />
            </v-col>
            <v-col cols="12" class="mb-n5">
              <v-btn :disabled="!valid" color="primary" @click="invite">Invite user</v-btn>
              <v-btn text @click="close">cancel</v-btn>
            </v-col>
          </v-row>
      </v-form>
    </template>
  </page>
</template>


<script>
export default {
  data() {
    return {
      authorization: "member",
      items: ["member", "owner"],
      member: "",
      valid: false,
      loading: true
    }
  },
  computed: {
    bcItems: function () {
      return [
        {},
        {
          text: "Organizations",
          disabled: false,
          exact: true,
          to: { name: "Organizations" },
        },
        {
          text: `${this.$route.params.organization}`,
          disabled: false,
          exact: true,
          to: { name: "OrganizationManagement" },
        },
        {
          text: "People",
          disabled: false,
          exact: true,
          to: { name: "OrganizationPeople" },
        },
        {
          text: `${this.$route.meta.bcText}`,
          disabled: false,
          exact: true,
          href: `${this.$route.path}`,
        },
      ]
    },
  },
  methods: {
    invite: function () {
      if (!this.$refs.form.validate()) {
        this.$refs.member.focus()
        return
      }
      const body = {searchstring: this.member}
      this.$api[
        this.authorization == "member"
          ? "addOrganizationMember"
          : "addOrganizationOwner"
      ](body, this.$route.params.organization, {}, this.callBack(
        ()=> {
          this.close()
        },
        error=> {
          if(error.status == 409) {
            this.alert("error", `User ${this.member} is already member`)
          }
        }
      ))
    }
  },
  mounted() {
    this.loading = false
  }
}
</script>